import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  GuestModel,
  GuestMutationInput,
  GuestDeleteInput,
  GuestUpdateInput,
  GuestMassUpdatePassportMutation,
  GuestUpdateDescriptionInput,
} from './model';

export function useCreateGuest(
  options?: UseMutationOptions<
    ApiResult<GuestModel>,
    ApiError,
    GuestMutationInput
  >,
): UseMutationResult<ApiResult<GuestModel>, ApiError, GuestMutationInput> {
  return useMutation<ApiResult<GuestModel>, ApiError, GuestMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'guests',
        method: 'POST',
        classType: GuestModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateGuest(
  options?: UseMutationOptions<
    ApiResult<GuestModel>,
    ApiError,
    GuestUpdateInput
  >,
): UseMutationResult<ApiResult<GuestModel>, ApiError, GuestUpdateInput> {
  return useMutation<ApiResult<GuestModel>, ApiError, GuestUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `guests/${body.guestId}`,
        method: 'PUT',
        classType: GuestModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteGuest(
  options?: UseMutationOptions<{ message: string }, ApiError, GuestDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, GuestDeleteInput> {
  return useMutation<{ message: string }, ApiError, GuestDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `guests/${body.guestId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useUpdateDescriptionGuest(
  options?: UseMutationOptions<any, ApiError, GuestUpdateDescriptionInput>,
): UseMutationResult<
  { message: string },
  ApiError,
  GuestUpdateDescriptionInput
> {
  return useMutation<
    { message: string },
    ApiError,
    GuestUpdateDescriptionInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `guests/${body.guestId}/update-description`,
      method: 'PATCH',
      body: body.body,
    });
  }, options);
}

export function useMassUpdatePassportGuest(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    GuestMassUpdatePassportMutation
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  GuestMassUpdatePassportMutation
> {
  return useMutation<
    { message: string },
    ApiError,
    GuestMassUpdatePassportMutation
  >(async function (body) {
    return await MutationFetchFunction({
      url: `guests/mass-update-passports`,
      method: 'PUT',
      body,
    });
  }, options);
}
